import "./Contact.css"
import {useTitle} from "../useTitle";

function Contact() {
  useTitle('Contact');

  return (
    <div className={"contact"}>
      <h2>Contact</h2>
      <ul>
        <li>Email: <a href="mailto:neoguid@hotmail.com">neoguid@hotmail.com</a></li>
        <li>AIM:  <a href="aim:goim?screenname=PizelThePenguin&amp;message=Oh+hei">Neoriceisgood</a></li>
        <li>MSN: neoguid@hotmail.com</li>
        <li>Yahoo: neoriceisneorice</li>
        <li>Skype: neoriceisgood</li>
      </ul>
    </div>
  );
}

export default Contact;